/* reservation.js — JUSTE UN MAILLOT (v7)
   Compteur de réservation panier, thème Impact.

   Corrections v6 -> v7 :
   - B7  Libération au vidage : le boot sync AUSSI un panier vide dès qu'un
         token existe (cookie "cart"). Sans ça, vider le panier ne prévenait
         jamais le backend -> réservation active 10 min pour rien.
   - B7b Pas de debounce sur un panier vide : Impact recharge la page à la
         suppression et tuait le setTimeout de 400 ms avant qu'il ne parte.
   - syncFromCart n'abandonne plus quand le panier est vide.

   Corrections v5 -> v6 (rappel) :
   - B1  Pas de timer optimiste : bandeau affiché QUE sur expires_at serveur.
   - B3  Ne POSTe jamais une liste plus courte que le panier source.
   - B6  Token normalisé (retrait du "?key=...").
   - M2  ensureBanner() et horloge dans start().
   - M3  Retry uniquement sur erreur transport.
   - M4  isCartPage() : regex seule.
   - M5  isDrawerOpen() : attribut [open].
   - Dédoublonnage : on n'écoute que cart:change.
   - Palette "variante 2b".

   Règles inchangées (ne jamais y toucher) :
   - AUCUN fetch /cart.js, AUCUN monkey-patch fetch/XHR
   - AUCUNE écriture DOM dans <cart-drawer>
   - Fail-open : n'empêche jamais un ajout au panier
*/
(function () {
  var BACKEND = "https://juste-un-maillot-reservation.vercel.app/api/reservations/sync";
  var TOTAL_SECONDS = 600;

  var syncing = false, pending = false, pendingCart = null;
  var expiryMs = null, hasItems = false, lastToken = null;
  var bannerEl = null, syncTimer = null;

  /* ---------------------------------------------------------------- styles */

  function injectFonts() {
    if (document.getElementById("jum-hold-fonts")) return;
    var l = document.createElement("link");
    l.id = "jum-hold-fonts";
    l.rel = "stylesheet";
    l.href = "https://fonts.googleapis.com/css2?family=Archivo:wght@500;700&family=Fredoka:wght@500;600&display=swap";
    document.head.appendChild(l);
  }

  function injectStyles() {
    if (document.getElementById("jum-hold-styles")) return;
    var css =
      "#jum-hold-banner{position:fixed;z-index:99999;display:none;align-items:center;gap:12px;" +
      "background:#3A2A1E;border:1px solid rgba(245,197,24,.22);border-radius:10px;padding:12px 16px;" +
      "font-size:14px;line-height:1.3;color:#F2EDE4;box-sizing:border-box;" +
      "font-family:'Archivo',system-ui,-apple-system,sans-serif;" +
      "transition:opacity .2s ease;box-shadow:0 8px 28px rgba(0,0,0,.22);pointer-events:none;}" +
      "#jum-hold-banner.is-visible{display:flex;}" +
      "#jum-hold-banner.is-drawer{top:12px;right:12px;}" +
      "#jum-hold-banner.is-page{top:12px;left:50%;transform:translateX(-50%);width:min(520px,calc(100vw - 24px));}" +
      "#jum-hold-banner .jum-hold__icon{flex:0 0 auto;line-height:0;color:#F5C518;opacity:.95;}" +
      "#jum-hold-banner .jum-hold__label{flex:1 1 auto;min-width:0;letter-spacing:.01em;}" +
      "#jum-hold-banner .jum-hold__time{flex:0 0 auto;background:#F5C518;color:#2A1D14;" +
      "font-family:'Fredoka',system-ui,sans-serif;font-weight:600;padding:5px 12px;border-radius:999px;" +
      "font-variant-numeric:tabular-nums;letter-spacing:.04em;min-width:52px;text-align:center;" +
      "white-space:nowrap;transition:background .3s ease,color .3s ease;}" +
      "#jum-hold-banner.is-urgent .jum-hold__time{background:#ff8a7a;color:#2A1D14;}" +
      "#jum-hold-banner.is-urgent .jum-hold__icon{color:#ff8a7a;}" +
      "@media (max-width:600px){#jum-hold-banner{gap:8px;padding:10px 12px;font-size:13px;}" +
      "#jum-hold-banner.is-drawer{top:8px;right:8px;}" +
      "#jum-hold-banner .jum-hold__time{padding:4px 10px;min-width:46px;}}" +
      "@media (max-width:380px){#jum-hold-banner .jum-hold__label{font-size:12px;}}";
    var s = document.createElement("style");
    s.id = "jum-hold-styles";
    s.textContent = css;
    document.head.appendChild(s);
  }

  function ensureBanner() {
    if (bannerEl) return bannerEl;
    if (!document.body) return null;
    bannerEl = document.createElement("div");
    bannerEl.id = "jum-hold-banner";
    bannerEl.setAttribute("role", "status");
    bannerEl.innerHTML =
      '<span class="jum-hold__icon" aria-hidden="true">' +
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
      'stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' +
      '<circle cx="12" cy="12" r="9"></circle><path d="M12 7v5l3 2"></path></svg></span>' +
      '<span class="jum-hold__label"></span><span class="jum-hold__time"></span>';
    document.body.appendChild(bannerEl);
    return bannerEl;
  }

  /* ----------------------------------------------------------------- token */

  function cookieValue(name) {
    var m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
    return m ? decodeURIComponent(m[1]) : null;
  }

  function normalizeToken(t) {
    if (!t) return null;
    t = String(t).split("?")[0].trim();
    return t.length > 5 ? t : null;
  }

  function cartToken(cart) {
    if (cart && cart.token) {
      var t = normalizeToken(cart.token);
      if (t) return t;
    }
    if (lastToken) return lastToken;
    var c = cookieValue("cart");
    if (c && c !== "null") return normalizeToken(c);
    return null;
  }

  /* ------------------------------------------------------------- affichage */

  function drawerEl() {
    return document.querySelector("cart-drawer, #cart-drawer, #CartDrawer");
  }

  function isDrawerOpen() {
    var d = drawerEl();
    if (!d) return false;
    if (!d.hasAttribute("open")) return false;
    var style = window.getComputedStyle(d);
    return style.visibility !== "hidden" && style.display !== "none";
  }

  function drawerWidth() {
    var d = drawerEl();
    if (!d) return 0;
    var w = d.getBoundingClientRect().width;
    return w > 80 ? w : 0;
  }

  function isCartPage() {
    try { return /^\/cart(\/|$|\?)/.test(location.pathname); }
    catch (e) { return false; }
  }

  function two(n) { return (n < 10 ? "0" : "") + n; }

  function hide(el) {
    el.classList.remove("is-visible", "is-drawer", "is-page", "is-urgent");
    el.style.width = "";
  }

  function tick() {
    var el = ensureBanner();
    if (!el) return;

    var onPage = isCartPage();
    var inDrawer = isDrawerOpen();
    if (!expiryMs || !hasItems || (!inDrawer && !onPage)) { hide(el); return; }

    var remaining = Math.round((expiryMs - Date.now()) / 1000);
    if (remaining <= 0) { hide(el); return; }

    el.classList.add("is-visible");
    el.classList.toggle("is-page", onPage);
    el.classList.toggle("is-drawer", inDrawer && !onPage);
    el.classList.toggle("is-urgent", remaining <= 60);

    if (inDrawer && !onPage) {
      var w = drawerWidth();
      el.style.width = w ? Math.max(240, w - 24) + "px" : "";
    } else {
      el.style.width = "";
    }

    var m = Math.floor(remaining / 60), s = remaining % 60;
    var narrow = (window.innerWidth || document.documentElement.clientWidth) <= 480;
    el.querySelector(".jum-hold__label").textContent = remaining <= 60
      ? (narrow ? "Bientôt terminée" : "Réservation bientôt terminée")
      : (narrow ? "Maillot réservé" : "On te garde ton maillot");
    el.querySelector(".jum-hold__time").textContent = two(m) + ":" + two(s);
  }

  /* ------------------------------------------------------------------ sync */

  function itemsFromCart(cart) {
    return (cart.items || []).map(function (i) {
      var vid = i.variant_id != null ? i.variant_id : i.id;
      return { variant_id: String(vid), quantity: Number(i.quantity) || 0 };
    }).filter(function (i) { return /^\d+$/.test(i.variant_id) && i.quantity > 0; });
  }

  function hasHoldFailure(data) {
    if (!data || !data.warnings || !data.warnings.length) return false;
    for (var i = 0; i < data.warnings.length; i++) {
      if (String(data.warnings[i]).indexOf("variant ") === 0) return true;
    }
    return false;
  }

  async function syncFromCart(rawCart) {
    if (!rawCart || typeof rawCart !== "object") return;
    var token = cartToken(rawCart);
    if (!token) return;

    if (syncing) { pending = true; pendingCart = rawCart; return; }
    syncing = true;
    pendingCart = null;
    lastToken = token;

    try {
      var sourceLines = (rawCart.items || []).filter(function (i) {
        return (Number(i.quantity) || 0) > 0;
      });
      var items = itemsFromCart(rawCart);

      // B3 : parsing partiel -> on n'envoie RIEN plutôt qu'une liste tronquée.
      // (un panier vide n'est PAS un parsing partiel : 0 === 0, on continue)
      if (items.length !== sourceLines.length) { syncing = false; return; }

      hasItems = items.length > 0;
      if (!hasItems) { expiryMs = null; tick(); }

      var data = null;
      for (var attempt = 0; attempt < 3; attempt++) {
        try {
          var resp = await fetch(BACKEND, {
            method: "POST",
            headers: { "Content-Type": "text/plain" },
            body: JSON.stringify({ token: token, items: items }),
            keepalive: true
          });
          data = await resp.json();
          break;
        } catch (e) {
          if (attempt === 2) throw e;
          await new Promise(function (r) { setTimeout(r, 300 * (attempt + 1)); });
        }
      }

      var confirmed = !!(data && data.ok && data.expires_at && hasItems && !hasHoldFailure(data));
      expiryMs = confirmed ? new Date(data.expires_at).getTime() : null;
      tick();
    } catch (e) {
      expiryMs = null;
      tick();
    }

    syncing = false;
    if (pending) {
      pending = false;
      var next = pendingCart; pendingCart = null;
      if (next) syncFromCart(next);
    }
  }

  // B7b : panier vidé = la page va se recharger, on POSTe immédiatement.
  function scheduleSync(cart) {
    if (syncTimer) clearTimeout(syncTimer);
    var empty = !cart || !cart.items || !cart.items.length;
    syncTimer = setTimeout(function () { syncFromCart(cart); }, empty ? 0 : 400);
  }

  function onCartChange(event) {
    var cart = event && event.detail && event.detail.cart;
    if (cart) scheduleSync(cart);
  }

  /* ------------------------------------------------------------------ boot */

  function bootFromLiquid() {
    var node = document.getElementById("jum-cart-boot");
    if (!node) {
      if (window.console) console.warn("[JUM] #jum-cart-boot absent de theme.liquid — pas de sync au chargement.");
      return;
    }
    try {
      var cart = JSON.parse(node.textContent || "{}");
      if (!cart) return;
      // B7 : on sync AUSSI un panier vide, dès qu'un token existe côté cookie.
      // Sinon la libération n'est jamais envoyée après un vidage.
      var hasLines = !!(cart.items && cart.items.length);
      if (hasLines || cookieValue("cart")) syncFromCart(cart);
    } catch (e) {}
  }

  function watchDrawerOpen() {
    var d = drawerEl();
    if (!d) return;
    new MutationObserver(function () { tick(); }).observe(d, {
      attributes: true,
      attributeFilter: ["open", "class", "style"]
    });
  }

  function start() {
    injectFonts();
    injectStyles();
    ensureBanner();
    setInterval(tick, 1000);
    document.addEventListener("cart:change", onCartChange);
    bootFromLiquid();
    watchDrawerOpen();
    tick();
  }

  if (document.readyState !== "loading") start();
  else document.addEventListener("DOMContentLoaded", start);
})();